import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue, useRecoilState } from "recoil";
import { awsInstance } from "../../actions/api";
import {
  userState,
  indicatorState,
  leftEmployeeCheckListState,
  rightEmployeeCheckListState,
} from "../../stores/atoms";
import Loading from "../Loading";
import GroupEmployeeItem from "./GroupEmployeeItem";

function GroupEmployee({ match }) {
  const [loading, setLoading] = useState(false);
  const [, setIndicator] = useRecoilState(indicatorState);
  const [leftEmployeeCheckList, setLeftEmployeeCheckList] = useRecoilState(
    leftEmployeeCheckListState
  );
  const [rightEmployeeCheckList, setRightEmployeeCheckList] = useRecoilState(
    rightEmployeeCheckListState
  );
  const user = useRecoilValue(userState);
  const [groupName, setGroupName] = useState("");
  const [leftSearch, setLeftSearch] = useState("");
  const [rightSearch, setRightSearch] = useState("");
  const [leftEmployeeList, setLeftEmployeeList] = useState([]);
  const [leftEmployeeOriginalList, setLeftEmployeeOriginalList] = useState([]);
  const [rightEmployeeList, setRightEmployeeList] = useState([]);
  const [rightEmployeeOriginalList, setRightEmployeeOriginalList] = useState([]);
  const [allLeftChecked, setAllLeftChecked] = useState(false);
  const [allRightChecked, setAllRightChecked] = useState(false);
  const [changed, setChanged] = useState(true);
  const history = useHistory();
  const groupId = match.params.id;

  useEffect(() => {
    setIndicator("홈 > 그룹 관리 > 직원 지정");

    async function getEmployees() {
      try {
        const { data } = await awsInstance.get("/business/group", {
          params: {
            id: groupId,
          },
        });
        if (data.code === "SUCCESS") {
          setGroupName(data.data.name);
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      }
      try {
        setLoading(true);
        const { data } = await awsInstance.get("/business/no-group/employee", {
          params: {
            id: user.company_id
          },
        });
        if (data.code === "SUCCESS") {
          setLeftEmployeeList(data.data);
          setLeftEmployeeOriginalList(data.data);
        } else if (data.code === "NO_DATA") {
          // Nothing
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
      try {
        setLoading(true);
        const { data } = await awsInstance.get("/business/group/employee", {
          params: {
            company_id: user.company_id,
            business_group_id: groupId
          },
        });
        if (data.code === "SUCCESS") {
          setRightEmployeeList(data.data);
          setRightEmployeeOriginalList(data.data);
        } else if (data.code === "NO_DATA") {
          // Nothing
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      } finally {
        setLoading(false);
      }
    }
    getEmployees();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      leftEmployeeList.length > 0 &&
      leftEmployeeList.length === leftEmployeeCheckList.length
    ) {
      setAllLeftChecked(true);
    } else {
      setChanged(false);
      setAllLeftChecked(false);
    }
    // eslint-disable-next-line
  }, [leftEmployeeCheckList]);

  useEffect(() => {
    if (
      rightEmployeeList.length > 0 &&
      rightEmployeeList.length === rightEmployeeCheckList.length
    ) {
      setAllRightChecked(true);
    } else {
      setChanged(false);
      setAllRightChecked(false);
    }
    // eslint-disable-next-line
  }, [rightEmployeeCheckList]);

  const onAllLeftEmployeeSelectChange = (e) => {
    setAllLeftChecked(e.target.checked);
    setChanged(true);
    if (e.target.checked) {
      setLeftEmployeeCheckList(leftEmployeeList.slice());
    } else {
      setLeftEmployeeCheckList([]);
    }
  };

  const onAllRightEmployeeSelectChange = (e) => {
    setAllRightChecked(e.target.checked);
    setChanged(true);
    if (e.target.checked) {
      setRightEmployeeCheckList(rightEmployeeList.slice());
    } else {
      setRightEmployeeCheckList([]);
    }
  };

  const onAddClick = () => {
    if (leftEmployeeCheckList.length === 0) {
      return;
    }
    for (const list of leftEmployeeCheckList) {
      leftEmployeeList.splice(leftEmployeeList.indexOf(list), 1);
    }
    setLeftEmployeeList(leftEmployeeList);
    setRightEmployeeList([...rightEmployeeList, ...leftEmployeeCheckList]);
    setLeftEmployeeCheckList([]);
    setRightEmployeeCheckList([]);
    setAllLeftChecked(false);
  };

  const onRemoveClick = () => {
    if (rightEmployeeCheckList.length === 0) {
      return;
    }
    for (const list of rightEmployeeCheckList) {
      rightEmployeeList.splice(rightEmployeeList.indexOf(list), 1);
    }
    setRightEmployeeList(rightEmployeeList);
    setLeftEmployeeList([...leftEmployeeList, ...rightEmployeeCheckList]);
    setLeftEmployeeCheckList([]);
    setRightEmployeeCheckList([]);
    setAllRightChecked(false);
  };

  const onSaveClick = async () => {
    const list = [];
    for (const employee of rightEmployeeList) {
      list.push(parseInt(employee.id));
    }
    try {
      setLoading(true);
      const { data } = await awsInstance.post("/business/group/employee", {
        business_group_id: groupId,
        employee_ids: list.join()
      });
      if (data.code === "SUCCESS") {
        alert("그룹에 직원이 지정되었습니다.");
        history.goBack();
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  
  const onChangeSearch = (e) => {
    const originLeftList = leftEmployeeOriginalList.slice();
    const originRightList = rightEmployeeOriginalList.slice();

    let originList = originRightList;
    if(e.target.name === 'rightSearch') {
      setRightSearch(e.target.value);
    } else {
      originList = originLeftList;
      setLeftSearch(e.target.value);
    }
    
    if(e.target.value) {
      const list = originList.filter(employee => {
        if(employee.department) {
          if(employee.name.indexOf(e.target.value) !== -1 || employee.email.indexOf(e.target.value) !== -1 || employee.department.indexOf(e.target.value) !== -1){
              return employee;
            } else {
              return null;
            }
        } else {
          if(employee.name.indexOf(e.target.value) !== -1 || employee.email.indexOf(e.target.value) !== -1){
              return employee;
            } else {
              return null;
            }
        }
        })
        if(e.target.name === 'rightSearch') {
          setRightEmployeeList(list);
        } else {
          setLeftEmployeeList(list);
        }
    } else {
      
      if(e.target.name === 'rightSearch') {
        setRightEmployeeList(originRightList);
      } else {
        setLeftEmployeeList(originLeftList);
      }
    }
  }

  return (
    <>
    <div className="group_employee fit-content">
      <h5>직원 지정</h5>
      <div className="display-flex justify-content-between">
        <p className="txt-gray">그룹의 직원을 추가하고 삭제합니다.</p>
      </div>
      <div className="table-area display-flex justify-content-between">
        <div className="width-35" style={{ minWidth: "26rem" }}>
          <table className="table w-100">
            <thead>
              <tr className="background-gray txt-white">
                <th>
                  <span>지정 가능한 직원 목록</span>
                </th>
              </tr>
              <tr>
                <th>
                  <input
                    type="text"
                    name="leftSearch"
                    className="form-control"
                    placeholder="이름, 이메일, 부서명 검색"
                    value={leftSearch}
                    onChange={onChangeSearch}
                  ></input>
                </th>
              </tr>
            </thead>
            <tbody className="txt-left overflow-y-auto height-60 d-block">
              <tr className="d-table w-100">
                <td>
                  <label htmlFor="select-all" className="m-1">
                    <input
                      id="select-all"
                      type="checkbox"
                      className="mr-2"
                      checked={allLeftChecked}
                      onChange={onAllLeftEmployeeSelectChange}
                    ></input>
                    모두 선택 ({leftEmployeeList.length}명)
                  </label>
                </td>
              </tr>
              {leftEmployeeList.map((value) => {
                return (
                  <GroupEmployeeItem
                    key={value.id}
                    employee={value}
                    isGroup={false}
                    allChecked={allLeftChecked}
                    changed={changed}
                    search={leftSearch}
                  />
                );
              })}
            </tbody>
          </table>
        </div>

        <div
          className="display-flex flex-column justify-content-center align-items-center width-30"
          style={{ minWidth: "10rem" }}
        >
          <button className="btn-white-md mb-4 p-2" onClick={onAddClick}>
            추가 <i className="fas fa-chevron-right ml-1" />
          </button>
          <button className="btn-white-md p-2" onClick={onRemoveClick}>
            <i className="fas fa-chevron-left ml-1" /> 삭제
          </button>
        </div>
        <div className="width-35" style={{ minWidth: "26rem" }}>
          <table className="table w-100">
            <thead>
              <tr className="background-gray txt-white">
                <th>
                  <span>{groupName} 직원 목록</span>
                </th>
              </tr>
              <tr className="d-table w-100">
                <th>
                  <input
                    type="text"
                    name="rightSearch"
                    className="form-control"
                    placeholder="이름, 이메일, 부서명 검색"
                    value={rightSearch}
                    onChange={onChangeSearch}
                  ></input>
                </th>
              </tr>
            </thead>
            <tbody className="txt-left overflow-y-auto height-60 d-block">
              <tr className="d-table w-100">
                <td>
                  <label htmlFor="select-all-second" className="m-1">
                    <input
                      id="select-all-second"
                      type="checkbox"
                      className="mr-2"
                      checked={allRightChecked}
                      onChange={onAllRightEmployeeSelectChange}
                    ></input>
                    모두 선택 ({rightEmployeeList.length}명)
                  </label>
                </td>
              </tr>
              {rightEmployeeList.map((value) => {
                return (
                  <GroupEmployeeItem
                    key={value.id}
                    employee={value}
                    isGroup={true}
                    allChecked={allRightChecked}
                    changed={changed}
                    search={rightSearch}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="display-flex justify-content-center mt-4">
        <button
          className="btn-white-md width-20 mr-4 p-2"
          onClick={() => history.goBack()}
        >
          이전
        </button>
        <button className="btn-blue-md width-20 p-2" onClick={onSaveClick}>
          저장
        </button>
      </div>
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default GroupEmployee;
